export default {"src":"/_next/static/media/icon-cancel.2c467c28.svg","height":16,"width":16};